import CantileverTheme from 'styles/cantileverTheme'

export const PRISM_GRAY = CantileverTheme.colors.grayscale[600]
export const PRISM_BORDER_GRAY = CantileverTheme.colors.grayscale[400]
export const PRISM_BORDER_GRAY_LOW_OPACITY = 'rgba(153,153,153,0.35)'
export const PRISM_INPUT_GRAY = 'rgba(40,40,40,1)'
export const PRISM_TABLE_ROW_BACKGROUND = PRISM_GRAY
export const PRISM_HEADER_COLOR = CantileverTheme.colors.grayscale[600]
export const PRISM_HIGHLIGHT_COLOR = CantileverTheme.colors.grayscale[500]
